import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { CustomProvider } from "./types";
import { jsonAuthHeaders } from "@/utils/headers";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { displayErrorToast } from "@/utils/toast";

export const usePatchProvider = ({ onSuccess }: { onSuccess: () => void }) => {
  const authContext = useAuth();
  const { workspaceId } = useParams();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (provider: CustomProvider) => {
      const response = await fetch(
        `${ENDPOINTS.providers(workspaceId ?? "")}/${provider.id}`,
        {
          method: "PUT",
          headers: jsonAuthHeaders(authContext?.userToken!),
          body: JSON.stringify(provider),
        },
      );
      return handleResponse(response);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["providers"],
      });
      onSuccess();
    },
    onError: (error: Error) => {
      displayErrorToast(error);
    },
  });
};
